export const downloadTemplate = async (endpoint: string, fileName?: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open('GET', endpoint, true);
    xhr.withCredentials = true;

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          // Extract filename from content-disposition header using regex (same as working example)
          const contentDisposition = xhr.getResponseHeader('content-disposition') || '';
          const contentType = xhr.getResponseHeader('content-type');
          const regex = /filename="(.*)"/gi;
          const groups = [...contentDisposition.matchAll(regex)][0];
          const filenameFromHeader = groups ? (groups[1] as string) : fileName || 'download';

          // Check if we have valid response data
          if (!xhr.response || xhr.response.size === 0) {
            throw new Error('Empty response received from server');
          }

          // Create File instead of Blob (same as working example)
          const file = new File([xhr.response], filenameFromHeader, { type: contentType });
          const href = URL.createObjectURL(file);

          // create "a" HTML element with href to file & click
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', filenameFromHeader);
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);

          resolve();
        } catch (error) {
          reject(error);
        }
      } else {
        reject(new Error(`HTTP error! status: ${xhr.status}`));
      }
    };

    xhr.onerror = function () {
      reject(new Error('Network error occurred'));
    };

    // Set response type to blob for proper binary data handling
    xhr.responseType = 'blob';
    xhr.send();
  });
};

// Convenience function for template downloads
export const downloadTemplateById = async (templateId: string): Promise<void> => {
  return downloadTemplate(`/api/templates/${templateId}`);
};
